<template>
  <div >
    <div >
      <div  style="display: flex;justify-content: flex-end;">
      <el-button @click="addSet">添加设置</el-button>
    </div>

      <div class="clock-list">
          <div class="unit"  v-for="(item, index) in pageProps.records" :key="index">
              <div>
                <div class="title">项目：{{item.project_name}}</div>
                <div class="title">职位：{{item.job_name}}</div>  
                <div class="title">{{item.title}}</div>
              </div>

              <div class="op">
                 <p class="btns"> 
                    <span @click="delHead(item)">删除</span>
                    <span @click="editHead(item)">编辑</span>
                </p>
              </div>
          </div>
      </div>

      <div style="text-align:center;padding:20px">
        <!--分页-->
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageProps.total"
          :page-size="pageProps.pageSize"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="pageProps.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

    </div>
    
  </div>
</template>

<script>
import { reportSetDel,reportSetLists } from "@/api/director/report/index.js";
export default {
    name: "Director-Work-CLock",
    data() {
      return {
       
        pageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },
        project_id:"",
        searchFormData:{
          name:"",
          project_id:"",
          page:0,
          limit:0
        }

      }
    },



    mounted () {
      console.log("this.$route.query",this.$route.query);
  
      if(this.$route.query&&this.$route.query.project_id){
        this.project_id=this.$route.query.project_id;
        this.searchFormData.project_id=this.$route.query.project_id;
        this.fetchData();
      }
     
    },


    methods: {

      reportList(type){
        
        this.$router.push({path:'/director-workmaster-report-list',query:{type:type}});

      },


      addSet(){
        this.$router.push({path:'/director-workmaster-report-set',query:{a:123456}});
        
      },
      editHead(item){
        this.$router.push({path:'/director-workmaster-report-set',query:{job_id:item.job_id,type:item.type}});
      },


      delHead(item){
        var that=this;
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          reportSetDel({id:item.id}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.fetchData();
              }
            });
          
        }).catch(() => {
        
        });
      },

     


      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        reportSetLists(that.searchFormData).then((response) => {
          console.log(response);
          if(response.code==200){
            that.pageProps.records = response.data.data;
            that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },

       // 当前页变更
      handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },


      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },
      
    }
  }
</script>
<style lang="scss" scoped>
::v-deep .main_box{
  background: #EEEBEC !important; 
}
.head{
  display: flex;
  justify-content: flex-start;
  background: #ffffff;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  img{
    width: 120px;
    height: 120px;
    margin-right: 20px;
  }
  .title{
    margin-top: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  .desc{
    margin-top: 10px;

  }
}


  .clock-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      display: flex;
      justify-content: space-between;
      background: #F6F6F6;
      align-items: center;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      &:hover{
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        background: #FFFFFF;
      }

      .title{
        font-size: 14px;
        padding: 5px;
      }
      .job{
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .op{
        display:flex;
        align-items: center;
      }
      .btns{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
    }
  }

</style>